import { GrYoga } from "react-icons/gr";
import { TbYoga } from "react-icons/tb";
import { CgGym } from "react-icons/cg";
import { FaRunning } from "react-icons/fa";

export const metodologyData = [
  {
    image: <CgGym />,
    heading: "Musculação",
    details:
      "Treinamentos focados no ganho de força e massa muscular, feito de forma individual e especializada para cada aluno.",
  },
  {
    image: <FaRunning />,
    heading: "Cardio",
    details:
      "Exercícios aeróbicos intensos para melhorar a resistência cardiovascular e promover a queima de gordura.",
  },
  {
    image: <GrYoga />,
    heading: "Flexibilidade",
    details:
      " Técnicas de alongamento para melhorar a amplitude de movimento e reduzir o risco de lesões.",
  },
  {
    image: <TbYoga />,
    heading: "Mobilidade",
    details:
      " Exercícios específicos para aumentar a capacidade funcional das articulações e promover movimentos mais fluídos e eficientes.",
  },
];
